import { SingleValueUserProfileSelect } from 'ui/queryBuilder/Selects';
import { UserProfileSelectProps } from 'modules/queryBuilder/contexts';
import { useFilterOptionsWithFeatureFlags } from './hooks';

export const CustomUserProfileSelect = ({ options = [], ...props }: UserProfileSelectProps) => {
  const filteredOptions = useFilterOptionsWithFeatureFlags(options);
  return <SingleValueUserProfileSelect options={filteredOptions} {...props} />;
};
